import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  Button,
  Box,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";
import { Autorenew } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import StatusTextDispaly from "../../../common/models/status/DeliveryCompleted";
import getColor from "../../../common/sasl/models/status/statusColors";
import moment from "moment";
import PaginationInput from "../../../common/models/pagination/PaginationInput";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    margin: theme.spacing(2, 0),
    border: "1px solid #ddd",
  },
  tableHead: {
    backgroundColor: "#f5f5f5",
  },
  tableCellHead: {
    // fontWeight: "bold",
    // textAlign: "center",
  },
  tableCell: {
    // textAlign: "center",
  },
  link: {
    color: "#1976d2",
    cursor: "pointer",

    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  chip: {
    width: "100%",
    fontWeight: "bold",
    borderRadius: "4px",
    backgroundColor: "#707070",
    color: "white",
  },
  chipGreen: {
    backgroundColor: "green",
    color: "white",
  },
  chipRed: {
    backgroundColor: "red",
    color: "white",
  },
  chipYellow: {
    backgroundColor: "#ffc107",
    color: "black",
  },
  chipBlue: {
    backgroundColor: "#007bff",
    color: "white",
  },
  remindButton: {
    backgroundColor: "#f5f5f5",
    border: "1px solid #ccc",
    color: "#333",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
}));

const ScheduledTable = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page
  const [totalPages, setTotalPages] = useState(1);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (val) => {
    setCurrentPage(val);
  };

  function handleView(batchNumber) {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/fgBatches/${batchNumber}`
    );
  }
  useEffect(() => {
    setTotalPages(Math.ceil(data.length / rowsPerPage));
  }, [data, rowsPerPage]);


  if (!data || data?.length === 0) {
    return (
      <Box
        style={{
          display: "flex",
          justifyContent: "center", // Horizontally center the CircularProgress
          alignItems: "center", // Vertically center the CircularProgress
          height: "50px", // Optional: Set a height to vertically center the loader
          border: "2px solid #000",
          // backgroundColor: "#FFF0F0",
          width: "100%",
          marginTop: "20px",
        }}
      >
        <Typography style={{ textAlign: "center" }}>
          No Records Found
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container justifyContent="flex-end">
      <Grid
        item
        alignContent="flex-end"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginLeft: "16px",
          marginTop: "-50px",
        }}
      >
        <Typography
          style={{
            fontWeight: "bold",
            marginRight: "4px",
            whiteSpace: "nowrap",
          }}
        >
          PER PAGE
        </Typography>
        <FormControl variant="outlined" size="small">
          <Select value={rowsPerPage} onChange={handleRowsPerPageChange}>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={15}>15</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.tableCellHead} align="left">
                Batch number
              </TableCell>
              <TableCell className={classes.tableCellHead} align="left">
                UoM
              </TableCell>
              <TableCell className={classes.tableCellHead} align="right">
                Batch size
              </TableCell>
              <TableCell className={classes.tableCellHead} align="left">
                Scheduled start date
              </TableCell>
              <TableCell className={classes.tableCellHead} align="right">
                Estimated qty.
              </TableCell>
              <TableCell className={classes.tableCellHead} align="left">
                Estimated date of delivery
              </TableCell>
              <TableCell className={classes.tableCellHead} align="center">
                Batch details
              </TableCell>
              <TableCell className={classes.tableCellHead} align="center">
                Batch status
              </TableCell>
              <TableCell className={classes.tableCellHead} align="center">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              ?.slice(
                (currentPage - 1) * rowsPerPage,
                (currentPage - 1) * rowsPerPage + rowsPerPage
              )
              .map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tableCell} align="left">
                    {row?.vendorBatchNumber || ""}
                  </TableCell>
                  <TableCell className={classes.tableCell} align="left">
                    {row?.uom || ""}
                  </TableCell>
                  <TableCell className={classes.tableCell} align="right">
                    {row?.batchSize || ""}
                  </TableCell>
                  <TableCell className={classes.tableCell} align="left">
                    {row?.scheduledStartDate
                      ? moment(row?.scheduledStartDate).format("DD-MMM-YYYY").toUpperCase()
                      : ""}
                  </TableCell>
                  <TableCell className={classes.tableCell} align="right">
                    {row?.estimatedQuantity || ""}
                  </TableCell>
                  <TableCell className={classes.tableCell} align="left">
                    {row?.estimatedDeliveryDate
                      ? moment(row?.estimatedDeliveryDate).format("DD-MMM-YYYY").toUpperCase()
                      : ""}
                  </TableCell>
                  <TableCell className={classes.tableCell} align="center">
                    <Link
                      className={classes.link}
                      onClick={() => handleView(row?.vendorBatchNumber)}
                    >
                      Click here to view
                    </Link>
                  </TableCell>
                  <TableCell className={classes.tableCell} align="center">
                    <StatusTextDispaly
                      statusText={row?.batchStatusText}
                      bgColor={getColor(row?.statusID)}
                    />
                  </TableCell>
                  <TableCell className={classes.tableCell} align="center">
                    <Button
                      variant="contained"
                      className={classes.remindButton}
                      startIcon={<Autorenew />}
                      disabled={true}
                    >
                      Remind
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length !== 0 ? (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{ paddingTop: "1rem" }}
        >
          <PaginationInput
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            page={currentPage}
          />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default ScheduledTable;
